


































import { Component, Vue, Prop } from 'vue-property-decorator';
import axios from 'axios';

import { Endpoints } from '@/ts/store/Constants';
import CorporationSelector from '@/components/Selects/CorporationSelector.vue';


@Component({
    components: {
        CorporationSelector,
    },
})

export default class ImportBulkPortfolioDataCard extends Vue {
    @Prop({ default: [] }) public readonly corporations: any;

    public submittingBulkPortfolioImportObject: boolean = false;

    public bulkPortfolioImportObject: any = {
        selectedCorporation: null,
        inputFile: null,
    };

     get canSubmitbulkPortfolioImport() {
        return (this.bulkPortfolioImportObject.selectedCorporation !== null && this.bulkPortfolioImportObject.inputFile !== null);
    }

    public resetBulkImportObject() {
        this.bulkPortfolioImportObject = {
            selectedCorporation: null,
            inputFile: null,
        };
    }

    public submitBulkPortfolioImport() {
        const headers = {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        };

        const formData = new FormData();
        formData.append('file', this.bulkPortfolioImportObject.inputFile);
        formData.append('corporationId', this.bulkPortfolioImportObject.selectedCorporation.id);

        axios.post(Endpoints.Neckbeard.IMPORT_BULK_PORTFOLIO_DATA, formData, headers)
            .then(() => {
                this.submittingBulkPortfolioImportObject = false;
                this.resetBulkImportObject();
                console.log('Succesful bulk portfolio import');
            })
            .catch((error) => {
                this.submittingBulkPortfolioImportObject = false;
                console.log('Error bulk portfolio import');
                console.log(error);
            });
    }
}
